export default {
    default:        '0deg 75deg 1m',
    sideText:       '300deg 105deg 1m',
    logoName:       '170deg 90deg 0.3m',
    description:    '180deg 90deg 0.3m',
}